<template>
  <div style="padding: 10px">
    <el-form ref="form" :model="form" label-width="120px" size="small" >
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>基础信息</span>
        </div>
        <slot name="form-item-task-displayName" :model="form" field="displayName">
          <el-form-item label="工作内容">
            <el-input v-model="form.displayName"></el-input>
          </el-form-item>
        </slot>
        <slot name="form-item-task-EMPNM" :model="form" field="EMPNM">
          <el-form-item label="责任人">
            <el-select
                style="width: 100%"
                v-model="form.EMPNM"
                placeholder="请选择责任人"
                clearable
                @change="handleAssigneeChange"
            >
              <el-option
                  v-for="u in userOptions"
                  :key="u.EMPNO"
                  :label="u.EMPNM"
                  :value="u.EMPNM"
              />
            </el-select>
          </el-form-item>
        </slot>
        <slot name="form-item-task-FRDTTM" :model="form" field="FRDTTM">
          <el-form-item label="要求开始日期">
            <el-date-picker
                v-model="form.FRDTTM"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </slot>
        <slot name="form-item-task-FINDTTM" :model="form" field="FINDTTM">
          <el-form-item label="要求完成日期">
            <el-date-picker
                v-model="form.FINDTTM"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </slot>
        <slot name="form-item-task-WKTY" :model="form" field="WKTY">
          <el-form-item label="工作类型">
            <el-input v-model="form.WKTY"></el-input>
<!--            <el-select-->
<!--                style="width: 100%"-->
<!--                v-model="form.WKTY"-->
<!--                placeholder="请选择工作类型"-->
<!--                clearable-->
<!--                multiple-->
<!--                @change="handleAssigneeChange"-->
<!--            >-->
<!--              <el-option-->
<!--                  v-for="u in userOptions"-->
<!--                  :key="u.EMPNO"-->
<!--                  :label="u.EMPNM"-->
<!--                  :value="u.EMPNO"-->
<!--              />-->
<!--            </el-select>-->
          </el-form-item>
        </slot>
        <slot name="form-item-task-ITEMTY" :model="form" field="ITEMTY">
          <el-form-item label="项目类型">
            <el-input v-model="form.ITEMTY"></el-input>
<!--            <el-select-->
<!--                style="width: 100%"-->
<!--                v-model="form.ITEMTY"-->
<!--                placeholder="请选择项目类型"-->
<!--                clearable-->
<!--                multiple-->
<!--                @change="handleAssigneeChange"-->
<!--            >-->
<!--              <el-option-->
<!--                  v-for="u in userOptions"-->
<!--                  :key="u.EMPNO"-->
<!--                  :label="u.EMPNM"-->
<!--                  :value="u.EMPNO"-->
<!--              />-->
<!--            </el-select>-->
          </el-form-item>
        </slot>
        <slot name="form-item-task-SRC" :model="form" field="SRC">
          <el-form-item label="动用资源">
            <el-input v-model="form.SRC"></el-input>
          </el-form-item>
        </slot>
        <slot name="form-item-task-OUTPUT" :model="form" field="OUTPUT">
          <el-form-item label="输出结果">
            <el-input v-model="form.OUTPUT"></el-input>
          </el-form-item>
        </slot>
        <slot name="form-item-task-REFIDTY" :model="form" field="REFIDTY">
          <el-form-item label="关联单据类型">
            <el-input v-model="form.REFIDTY"></el-input>
<!--            <el-select-->
<!--                style="width: 100%"-->
<!--                v-model="form.REFIDTY"-->
<!--                placeholder="请选择关联单据类型"-->
<!--                clearable-->
<!--                multiple-->
<!--                @change="handleAssigneeChange"-->
<!--            >-->
<!--              <el-option-->
<!--                  v-for="u in userOptions"-->
<!--                  :key="u.EMPNO"-->
<!--                  :label="u.EMPNM"-->
<!--                  :value="u.EMPNO"-->
<!--              />-->
<!--            </el-select>-->
          </el-form-item>
        </slot>
        <slot name="form-item-task-REFIDNO" :model="form" field="name1">
          <el-form-item label="关联单据编码">
            <el-input v-model="form.REFIDNO"></el-input>
          </el-form-item>
        </slot>
        <slot name="form-item-task-RMK" :model="form" field="RMK">
          <el-form-item label="备注">
            <el-input v-model="form.RMK"></el-input>
          </el-form-item>
        </slot>
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>操作按钮</span>
        </div>
        <slot name="form-item-task-actionBtns" :model="form" field="actionBtns">
          <div>
            <el-checkbox
                :indeterminate="actionIndeterminate"
                v-model="actionCheckAll"
                @change="handleActionCheckAll"
            >
              全选
            </el-checkbox>
          </div>
          <div>
            <!-- 按钮列表 -->
            <el-checkbox-group
                v-model="form.actionBtns"
                @change="handleActionBtnChange"
            >
              <el-checkbox
                  v-for="item in actionBtnOptions"
                  :key="item.value"
                  :label="item.value"
              >
                {{ item.label }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </slot>
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>扩展属性</span>
        </div>
        <slot name="form-item-task-width" :model="form" field="width">
          <el-form-item label="宽度">
            <el-input-number :step="5" :step-strictly="true" v-model="form.width"></el-input-number>
          </el-form-item>
        </slot>
        <slot name="form-item-task-height" :model="form" field="height">
          <el-form-item label="高度">
            <el-input-number :step="5" :step-strictly="true" v-model="form.height"></el-input-number>
          </el-form-item>
        </slot>
      </el-card>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default () {
        return {}
      }
    },
    extendAttrConfig: { // 扩展属性配置
      type: Object
    }
  },
  data () {
    return {
      checkList: [],
      activeName: 'first',
      form: this.value,
      attrKey: '',
      field: this.value.field || {},
      actionBtnOptions: [
        { label: '同意', value: 'AGREE' },
        { label: '拒绝', value: 'REJECT' },
        { label: '退回上一步', value: 'ROLLBACK' },
        { label: '驳回', value: 'ROLLBACK_TO_OPERATOR' },
        { label: '跳转', value: 'JUMP' }
      ],
      actionCheckAll: false,
      actionIndeterminate: false,
      userOptions: []
    }
  },
  watch: {
    form: {
      handler (n) {
        this.$emit('change', n)
      },
      deep: true
    },
    'form.actionBtns': {
      handler (list) {
        if (!list) {
          this.actionCheckAll = false
          this.actionIndeterminate = false
          return
        }

        const total = this.actionBtnOptions.length
        const checkedCount = list.length

        this.actionCheckAll = checkedCount === total
        this.actionIndeterminate = checkedCount > 0 && checkedCount < total
      },
      immediate: true
    },
    value: {
      handler (n) {
        this.form = n
      },
      deep: true
    },
    field: {
      handler (n) {
        this.$set(this.form, 'field', JSON.parse(JSON.stringify(this.field)))
      },
      deep: true
    }
  },
  created() {
    this.getUserList()
  },
  methods: {
    // 人员
    getUserList(){
      this.$axios({
        method: 'post',
        url: 'xuper_api/getBaseData',
        data: {p_table:'v_d_emp'},
      }).then(res=>{
        if (res.code==='200'){
          this.userOptions =res.result
        }
      })
    },
    handleAssigneeChange(val) {
        const user = this.userOptions.find(u => u.EMPNM === val)
        this.form.EMPIDSEQ = user ? user.IDSEQ : ''
    },
    // 全选 / 取消全选
    handleActionCheckAll (val) {
      if (!Array.isArray(this.form.actionBtns)) {
        this.$set(this.form, 'actionBtns', [])
      }

      this.form.actionBtns = val
          ? this.actionBtnOptions.map(item => item.value)
          : []

      this.actionIndeterminate = false
    },

    // 单个按钮变更
    handleActionBtnChange (list) {
      const checkedCount = list.length
      const total = this.actionBtnOptions.length

      this.actionCheckAll = checkedCount === total
      this.actionIndeterminate = checkedCount > 0 && checkedCount < total
    },
  }
}
</script>

<style scoped>
.box-card{
  border-radius: 8px;
  margin-bottom: 20px;
}
.clearfix{
  font-size: 16px;
  font-weight: bold;
}
</style>
